import { useFormikContext } from 'formik';
import {
  KidsPriceFormType,
  KidsPriceType,
  PriceFormType,
} from '../../../redux/types/pricesTypes';

import styles from './ObjectKidsPrice.module.scss';
import { ButtonType } from '../../../utils/@globalTypes';
import Button from '../../Button';
import { DeleteIcon } from '../../../assets/icons';
import useWindowDimensions from '../../../utils/useWindowDimensions';
import KidsPriceItem from '../KidsPriceItem/KidsPriceItem';
import KidsFreeBlock from '../../KidsFreeBlock';
import { useEffect } from 'react';

const ObjectKidsPrice = () => {
  const {
    setFieldValue,
    values,
    setFieldTouched,
    setFieldError,
    errors,
    dirty,
    isValid,
  } = useFormikContext<PriceFormType>();
  // console.log(dirty, isValid)
  const { width } = useWindowDimensions();

  const newKidsBlock: KidsPriceFormType = {
    start_age: 0,
    end_age: null,
    price: {
      high_season_weekday_price: '',
      high_season_weekend_price: '',
      low_season_weekday_price: '',
      low_season_weekend_price: '',
    },
  };

  const addAgeRange = () => {
    const arrLength = values.kidsPrice.length;
    if (
      values.kidsPrice.length === 0 ||
      (arrLength > 0 && values.kidsPrice[arrLength - 1].end_age)
    ) {
      const newBlock = { ...newKidsBlock };
      const newKids = [...values.kidsPrice, newBlock];
      setFieldValue('kidsPrice', newKids);
      setFieldTouched('kidsPrice');
    }
  };
  // useEffect(() => {
  //   if(errors.kidsPrice?.length>0){

  //   }
  // }, [errors]);

  return (
    <div className={styles.container}>
      <KidsFreeBlock />
      {values.kidsPrice?.length > 0 &&
        values.kidsPrice.map((item, index) => {
          return <KidsPriceItem key={index} index={index} />;
        })}
      <div className={styles.btnWrap}>
        <div className={styles.btnAdd}>
          <Button
            title={width > 600 ? 'Добавить возрастной диапазон' : '+'}
            type={ButtonType.PRIMARY_SMALL}
            disabled={
              (values.kidsPrice.length > 0 &&
                !values.kidsPrice[values.kidsPrice.length - 1]?.end_age) ||
              (values.kidsPrice.length > 0 &&
                values.kidsPrice[values.kidsPrice.length - 1]?.end_age == 17) ||
              values.kidsPrice[values.kidsPrice.length - 1]?.end_age == 16 ||
              values.ageKidsFree === '17'
            }
            onClick={() => {
              addAgeRange();
            }}
          />
        </div>
        {values.kidsPrice?.length > 0 && (
          <div className={styles.btnRemove}>
            <Button
              title={
                width > 600 ? 'Удалить возрастной диапазон' : <DeleteIcon />
              }
              type={ButtonType.SECONDARY_SMALL}
              onClick={() => {
                const newArr = [...values.kidsPrice];
                newArr.pop();
                setFieldValue('kidsPrice', newArr);
                setFieldTouched('kidsPrice', false);
                setFieldError('kidsPrice', undefined);
              }}
              confirmWindowText="Вы действительно хотите удалить?"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ObjectKidsPrice;
